import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LoginAxios from "../api/LoginAxios";
import { processIframes } from "../IframeHelper";
import { useDispatch } from "react-redux";
import { resetNotifications } from "../store/slices/notificationSlice";
import Spinner from "../components/Spinner";
const Logout = () => {
  const history = useNavigate();
  const userInfo = useSelector((state) => state?.user?.data);
  const leftMenuNames = userInfo?.left_menu;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetNotifications());
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = async () => {
    try {
      const res = await LoginAxios.get("/logout/");
      await processIframes(leftMenuNames, dispatch);
      localStorage.removeItem("token");

      localStorage.clear();
      console.log(res);
      history("/");
    } catch (err) {
      console.error("Error during logout:", err);
      await processIframes(leftMenuNames, dispatch);
      localStorage.removeItem("token");
      localStorage.clear();
      history("/");
    }
  };

  return <Spinner />;
};

export default Logout;
